import React from 'react';

import { SwitchButtonContextProps } from './interface';

const CONTEXT = React.createContext<SwitchButtonContextProps>({});
export default CONTEXT;
